import { api } from './client'
import { RefreshTokenInvalidError } from './errors'
import type { UserProfile } from '@/types'

export function initiateLogin(): void {
  window.location.href = '/api/auth/steam'
}

export async function fetchMeWithToken(token: string): Promise<UserProfile> {
  const response = await fetch('/api/auth/me', {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new Error('Failed to fetch profile')
  return response.json() as Promise<UserProfile>
}

export function fetchMe(): Promise<UserProfile> {
  return api.get<UserProfile>('/auth/me')
}

export function logout(): Promise<void> {
  return api.post<void>('/auth/logout')
}

// Uses raw fetch — calling api.post here would risk an infinite retry loop
// if the refresh endpoint itself returned a 401.
export async function refreshAccessToken(refreshToken: string): Promise<string> {
  const response = await fetch('/api/auth/refresh', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh_token: refreshToken }),
  })
  if (response.status === 401) throw new RefreshTokenInvalidError()
  if (!response.ok) throw new Error('Refresh failed')
  const data = (await response.json()) as { access_token: string }
  return data.access_token
}
